var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"main-layer__front main-layer__front__top"},[_c('div',{staticClass:"t-container py-12"},[_c('ListMenu'),_c('p',[_vm._v("Copyright © Tokyu Corporation All Right Reserved")])],1),_c('CallCenterDialog')],1)}
var staticRenderFns = []

export { render, staticRenderFns }